import gql from "graphql-tag";

export default gql`
mutation archiveAddScreen ($profile: ScreenProfile!, $resourceId: ID!) {
    archiveAddScreen (profile: $profile, resourceId: $resourceId) {
        id,
        success,
        message
    }
}`